import moment from "moment-timezone";
import apiFactory from "@/helpers/api";

const {
	get: userAPIGet,
	put: userAPIPut,
	post: userAPIPost,
} = apiFactory();

export const saveUserProfile = ( { userProfile, } ) => {
	return userAPIPut( "/user/me", userProfile );
};

export const saveUserSettings = settings => {
	return userAPIPost( "/user/me/settings", settings );
};

export const saveAssessmentResult = ( { assessment, } ) => {
	return userAPIPost( "/user/me/assessment", assessment );
};

export const getUserProfile = async () => {
	const userProfile = await userAPIGet( "/user/me" );

	userProfile.isFreeTrialExpired = false;

	const onboarding = userProfile?.onboarding || {};

	if ( onboarding.isComplete ) {
		const lastOnboardingStepCompletedAt = Math.max(
			0, ...Object.values( onboarding?.completedSteps || {} )
		);
		onboarding.completedAt = moment.unix( lastOnboardingStepCompletedAt )
			.toISOString();
		const now = moment.utc();
		const usedTrialDays = Math.min( userProfile.freeTrialDays, now.diff( onboarding.completedAt, "days" ) );
		userProfile.isFreeTrialExpired = ( usedTrialDays === userProfile.freeTrialDays );
		userProfile.onboarding = onboarding;
	}

	return Promise.resolve( userProfile );
};

export const getTeammates = () => {
	return userAPIGet( "/user/me/teammates" );
};



// WEBPACK FOOTER //
// ./src/api/userAPI.js